import * as React from "react";

function SvgOffices(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 19h4m5 0V3a2 2 0 00-2-2H5a2 2 0 00-2 2v16h14zm0 0h2-2zm0 0h-5 5zM3 19H1h2zm0 0h5-5zM7 5h1-1zm0 4h1-1zm5-4h1-1zm0 4h1-1zM8 19v-5a1 1 0 011-1h2a1 1 0 011 1v5H8z"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgOffices;
